/* halcyra — section behaviour and motion.
   Every module is optional: a section that isn't on the page simply
   doesn't initialise. Motion One (assets/motion.min.js) is used where it
   is present; if it fails to load, everything still works, just without
   the animation. Safe to load on every template. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var M = window.Motion || null;
  var animate = M && M.animate;
  var scrollFn = M && M.scroll;
  var stagger = M && M.stagger;

  /* Elements start hidden only when we can actually animate them in.
     Without this class a no-JS or no-Motion visitor sees the page as-is. */
  /* Hide only what we are about to animate, and only inline, so there is no
     stylesheet rule left underneath to re-hide it afterwards. */
  function arm(els) {
    if (!animate || reduce) return els;
    els.forEach(function (e) { e.style.opacity = '0'; });
    return els;
  }

  /* Belt and braces: if an animation never runs, nothing stays invisible.
     Only elements actually on screen are swept. A blanket sweep would un-hide
     every card further down the page too, and they would then be sitting at
     full opacity before the visitor ever scrolled to them, which kills the
     reveal. Repeating the check covers sections reached later. */
  if (animate && !reduce) {
    var sweeps = 0;
    var timer = setInterval(function () {
      document.querySelectorAll('[style*="opacity: 0"], [style*="opacity:0"]')
        .forEach(function (e) {
          var r = e.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0 && r.width) {
            e.style.opacity = ''; e.style.transform = '';
          }
        });
      if (++sweeps > 30) clearInterval(timer);
    }, 2000);
  }

  var EASE = [0.22, 0.61, 0.36, 1];

  /* Motion cannot interpolate a transform list to the keyword `none`; doing so
     collapses the element to matrix(0,0,0,0,0,0), i.e. scaled out of existence.
     Every keyframe below therefore ends on an explicit identity transform, and
     settle() hands the element back to the stylesheet once it lands. */
  function settle(anim, els) {
    function clear() { els.forEach(function (e) { e.style.transform = ''; e.style.opacity = ''; }); }
    if (!anim || !anim.finished) { clear(); return; }
    anim.finished.then(clear).catch(clear);
  }

  function show(els, opts) {
    opts = opts || {};
    if (!els.length) return;
    if (!animate || reduce) {
      els.forEach(function (e) { e.style.opacity = 1; e.style.transform = 'none'; });
      return;
    }
    arm(els);
    settle(animate(els,
      { opacity: [0, 1], transform: [opts.from || 'translateY(24px)', opts.to || 'translateY(0px)'] },
      { duration: opts.duration || 0.75, delay: opts.delay || 0, easing: EASE }), els);
  }

  /* ---------- marquee: duplicate the run so the loop has no seam ---------- */
  document.querySelectorAll('[data-halcyra-ticker]').forEach(function (t) {
    if (!t.dataset.doubled) { t.innerHTML += t.innerHTML; t.dataset.doubled = '1'; }
  });

  /* ---------- hero: one orchestrated entrance ---------- */
  (function () {
    var copy = document.querySelector('.hero-copy');
    var art = document.querySelector('.hero-art');
    if (!copy && !art) return;

    var lines = copy ? Array.prototype.slice.call(copy.children) : [];
    if (animate && !reduce && stagger) {
      arm(lines);
      settle(animate(lines, { opacity: [0, 1], transform: ['translateY(26px)', 'translateY(0px)'] },
        { duration: 0.8, delay: stagger(0.07, { start: 0.05 }), easing: EASE }), lines);
    } else {
      lines.forEach(function (e) { e.style.opacity = 1; e.style.transform = 'none'; });
    }
    if (art) show([art], { from: 'translateY(30px) scale(.985)', to: 'translateY(0px) scale(1)',
                           delay: 0.18, duration: 0.9 });
  })();

  /* ---------- hero: pointer tilt on three planes ---------- */
  (function () {
    var art = document.querySelector('.hero-art');
    var tilt = art && art.querySelector('.hero-tilt');
    if (!tilt || reduce) return;
    if (window.matchMedia('(hover: none)').matches) return;  // no tilt on touch

    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;

    function loop() {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      tilt.style.transform = 'rotateY(' + cx.toFixed(2) + 'deg) rotateX(' + cy.toFixed(2) + 'deg)';
      raf = (Math.abs(tx - cx) > 0.01 || Math.abs(ty - cy) > 0.01) ? requestAnimationFrame(loop) : null;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(loop); }

    art.addEventListener('pointermove', function (e) {
      var r = art.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 9;
      ty = -((e.clientY - r.top) / r.height - 0.5) * 7;
      kick();
    });
    art.addEventListener('pointerleave', function () { tx = 0; ty = 0; kick(); });
  })();

  /* ---------- scroll reveal ----------
     Deliberately does NOT pre-hide anything. Content is visible by default and
     the animation starts the instant the observer fires, so if the observer
     never fires the failure is "no animation", not "no content". Two bugs in
     this session came from hiding first and relying on something later to
     un-hide; that trade is not worth a fade.

     Uses a plain IntersectionObserver rather than Motion's inView so the
     visibility path has no dependency on the animation library at all. */
  var canObserve = 'IntersectionObserver' in window;

  if (canObserve) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { revealIO.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  if (canObserve && animate && !reduce) {
    ['.detail-grid', '.rev-grid', '.fit-row'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (grid) {
        /* Only cards that start below the fold get an entrance; anything
           already on screen at load stays as it is rather than flashing. */
        if (grid.getBoundingClientRect().top < window.innerHeight) return;
        var kids = Array.prototype.slice.call(grid.children);
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          settle(animate(kids,
            { opacity: [0, 1], transform: ['translateY(28px) rotateX(6deg)', 'translateY(0px) rotateX(0deg)'] },
            { duration: 0.7, delay: stagger ? stagger(0.09) : 0, easing: EASE }), kids);
        }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
        io.observe(grid);
      });
    });
  }

  /* ---------- the angle bench ---------- */
  document.querySelectorAll('[data-bench]').forEach(function (root) {
    var HX = 330, HY = 340, R = 100;
    var armA = root.querySelector('[data-arm-a]'),
        armB = root.querySelector('[data-arm-b]'),
        sweep = root.querySelector('[data-sweep]'),
        ticks = root.querySelector('[data-ticks]'),
        degOut = root.querySelector('[data-deg-out]'),
        modeOut = root.querySelector('[data-mode]'),
        range = root.querySelector('[data-range]'),
        list = root.querySelector('[data-bench-list]');
    if (!armA || !range) return;

    var L_FOLDED = root.dataset.labelFolded || 'Folded flat',
        L_CORNER = root.dataset.labelCorner || 'Corner',
        L_STRAIGHT = root.dataset.labelStraight || 'Straight run';

    function polar(deg, r) {
      var rad = deg * Math.PI / 180;
      return [HX + r * Math.cos(rad), HY + r * Math.sin(rad)];
    }

    if (ticks && !ticks.childNodes.length) {
      [0, 45, 90, 135, 180].forEach(function (t) {
        var a = -180 + t, p1 = polar(a, 128), p2 = polar(a, 138);
        var l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        l.setAttribute('x1', p1[0].toFixed(1)); l.setAttribute('y1', p1[1].toFixed(1));
        l.setAttribute('x2', p2[0].toFixed(1)); l.setAttribute('y2', p2[1].toFixed(1));
        ticks.appendChild(l);
      });
    }

    function label(d) {
      if (d <= 4) return L_FOLDED;
      if (d >= 176) return L_STRAIGHT;
      if (d > 84 && d < 96) return L_CORNER;
      return 'Open ' + d + '°';
    }

    function render(deg) {
      var a1 = -90 - deg / 2, a2 = -90 + deg / 2;
      armA.setAttribute('transform', 'rotate(' + a1.toFixed(2) + ' ' + HX + ' ' + HY + ')');
      armB.setAttribute('transform', 'rotate(' + a2.toFixed(2) + ' ' + HX + ' ' + HY + ')');

      var s = polar(a1, R), e = polar(a2, R);
      sweep.setAttribute('d', deg < 1 ? '' :
        'M ' + s[0].toFixed(1) + ' ' + s[1].toFixed(1) +
        ' A ' + R + ' ' + R + ' 0 0 1 ' + e[0].toFixed(1) + ' ' + e[1].toFixed(1));

      if (degOut) degOut.innerHTML = deg + '<sup>°</sup>';
      if (modeOut) modeOut.textContent = label(deg);

      root.querySelectorAll('[data-preset]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Math.abs(+b.dataset.preset - deg) < 3));
      });
      if (list) list.querySelectorAll('li').forEach(function (li) {
        li.dataset.active = String(Math.abs(+li.dataset.deg - deg) < 12);
      });
    }

    var raf;
    function animateTo(target) {
      if (reduce) { range.value = target; render(target); return; }
      cancelAnimationFrame(raf);
      var from = +range.value, t0 = performance.now(), dur = 620;
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur);
        var v = Math.round(from + (target - from) * (1 - Math.pow(1 - k, 3)));
        range.value = v; render(v);
        if (k < 1) raf = requestAnimationFrame(step);
      })(t0);
    }

    /* Scroll drives the hinge until the visitor takes over. The shelf's one
       trick is that it opens, so the page opens it for them on the way past;
       the moment they touch the slider or a preset, scroll lets go for good. */
    var manual = false;
    function takeOver() { manual = true; }

    range.addEventListener('input', function () { takeOver(); render(+range.value); });
    range.addEventListener('pointerdown', takeOver);
    root.querySelectorAll('[data-preset]').forEach(function (b) {
      b.addEventListener('click', function () { takeOver(); animateTo(+b.dataset.preset); });
    });
    if (list) list.querySelectorAll('li').forEach(function (li) {
      li.addEventListener('click', function () { takeOver(); animateTo(+li.dataset.deg); });
    });

    render(+range.value);

    if (scrollFn && !reduce) {
      scrollFn(function (progress) {
        if (manual) return;
        var deg = Math.round(Math.max(0, Math.min(1, progress)) * 180);
        range.value = deg;
        render(deg);
      }, { target: root, offset: ['start 85%', 'end 55%'] });
    } else if (canObserve && !reduce) {
      var seen = false;
      var benchIO = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || seen || manual) return;
        seen = true; benchIO.disconnect();
        var target = +range.value;
        range.value = 0; render(0);
        setTimeout(function () { if (!manual) animateTo(target); }, 260);
      }, { threshold: 0.4 });
      benchIO.observe(root);
    }
  });

  /* ---------- faucet fit check ---------- */
  document.querySelectorAll('[data-fit]').forEach(function (root) {
    var verdict = root.querySelector('[data-verdict]'),
        badge = verdict.querySelector('[data-verdict-badge]'),
        title = verdict.querySelector('[data-verdict-title]'),
        body = verdict.querySelector('[data-verdict-body]');
    if (!verdict) return;

    root.querySelectorAll('[data-fit-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-fit-opt]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var state = btn.dataset.fitOpt;
        verdict.dataset.state = state;
        badge.textContent = state === 'yes' ? '✓' : '✕';
        title.textContent = btn.dataset.verdictTitle || '';
        body.textContent = btn.dataset.verdictBody || '';
        if (animate && !reduce) {
          animate(verdict, { transform: ['scale(.985)', 'scale(1)'], opacity: [0.4, 1] },
            { duration: 0.35, easing: EASE });
        }
      });
    });
  });

  /* ---------- room tabs ---------- */
  document.querySelectorAll('[data-rooms]').forEach(function (root) {
    root.querySelectorAll('[data-room-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('[data-room-tab]').forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
        tab.setAttribute('aria-selected', 'true');
        root.querySelectorAll('[data-room-panel]').forEach(function (p) {
          var open = p.dataset.roomPanel === tab.dataset.roomTab;
          p.dataset.open = String(open);
          if (open && animate && !reduce) {
            var kids = Array.prototype.slice.call(p.children);
            settle(animate(kids, { opacity: [0, 1], transform: ['translateY(16px)', 'translateY(0px)'] },
              { duration: 0.5, delay: stagger ? stagger(0.06) : 0, easing: EASE }), kids);
          }
        });
      });
    });
  });
})();
